import TagManager from 'react-gtm-module'
export const buttonClick = (buttonName, buttonId) => {
  TagManager.dataLayer({
    dataLayer: {
      event: "buttonClick",
      page_name: 'EH',
      button_name: buttonName,
      button_ID: buttonId
    }
  })
}

export const productClick = (buttonName, buttonId, contentTitle, destinationURL) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'productClick',
      page_name: 'EH',
      button_name: buttonName,
      button_ID: buttonId,
      content_title: contentTitle, 
      destination_URL: destinationURL
    }
  })
}


export const viewItemList = (itemListId, itemListName, productCard) => {
  const items = productCard.map((ele)=>({
    item_id: ele.id,
    item_name: ele.nameHK,
    index: ele.index,
    price: ele.price,
    coupon: ele.discountprice
  }))
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  })
  TagManager.dataLayer({
    dataLayer: {
      event: "view_item_list",
      ecommerce: {
        item_list_id: itemListId,
        item_list_name: itemListName,
        items: items
      }
    }
  })
}

export const selectItem = (itemListId, itemListName, item,index) => {
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  })
  TagManager.dataLayer({
    dataLayer: {
      event: "select_item",
      ecommerce: {
        item_list_id: itemListId,
        item_list_name: itemListName,
        items: [
          {
            item_id: item.id || item.item_id,
            item_name: item.nameHK || item.item_name,
            index: index,
            price: item.price
          }
        ]
      }
    }
  })
}

export const viewItem = (ecommerce) => {
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  })
  TagManager.dataLayer({
    dataLayer: {
      event: "view_item",
      ecommerce: ecommerce
    }
  })
}


export const articleClick = (buttonName, buttonId, contentTitle, destinationURL) => {
  TagManager.dataLayer({
    dataLayer:{
      event: "articleClick",
      page_name: "EH",
      button_name: buttonName,
      button_ID: buttonId,
      content_title: contentTitle,
      destination_URL: destinationURL
    }
  })
}

export const loginOrSignEvent = (event, method) => {
  TagManager.dataLayer({
    dataLayer: {
      event: event,
      method: method
    }
  })
}


export const addShippingInfo = (ecommerce) => {
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  })
  TagManager.dataLayer({
    dataLayer: {
      event: "add_shipping_info",
      ecommerce: ecommerce
    }
  })
}

export const addPaymentInfo = (ecommerce) => {
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  })
  TagManager.dataLayer({
    dataLayer: {
      event: "add_payment_info",
      ecommerce: ecommerce
    }
  })
}

export const addToCart = (ecommerce) => {
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  })
  TagManager.dataLayer({
    dataLayer: {
      event: "add_to_cart",
      ecommerce: ecommerce
    }
  })
}


export const beginCheckout = (ecommerce) => {
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  })
  TagManager.dataLayer({
    dataLayer: {
      event: "begin_checkout",
      ecommerce: ecommerce
    }
  })
}

export const purchase = (ecommerce) => {
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  })
  TagManager.dataLayer({
    dataLayer: {
      event: "purchase",
      ecommerce: ecommerce
    }
  })
}

export const contentClick = (buttonName, buttonId, contentTitle) => {
  TagManager.dataLayer({
    dataLayer: {
      event: "contentClick",
      page_name: "EH",
      button_name: buttonName,
      button_ID: buttonId,
      content_title: contentTitle  
    }
  })
}
